var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('b-button',{staticClass:"code border-0",attrs:{"variant":"light"},on:{"click":function($event){return _vm.onClick()}}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }